import React from 'react';
import Button from 'react-bootstrap/Button';
import ModalWrapper from './ModalWrapper';

const AlertModal = ({
    show,
    onHide,
    title = 'Alert',
    handleConfirm,
    saveButtonText = 'Yes',
    cancelButtonText = 'Not Now',
    message = 'Are you sure you want to take this action?',
}) => {
    return (
        <ModalWrapper
            show={show}
            onHide={onHide}
            headerClass='w-100 text-start'
            title={title}
            showFooter={false}
        >
            <p>{message}</p>
            <div className='modal-actions'>
                <button 
                    type='button' 
                    className='filters-btn'
                    onClick={() => onHide()}
                >
                    {cancelButtonText}
                </button>
                <Button 
                    variant='primary' 
                    onClick={() => handleConfirm()}
                    className='modal-confirm-btn'
                >
                    {saveButtonText}
                </Button>
            </div>
        </ModalWrapper>
    );
};

export default AlertModal;
